<template>
    <div class="award-badge" :style="{ borderColor: blok.Color.color, color: blok.Color.color }">
        <NuxtImg
            v-if="blok.Image?.filename"
            :src="blok.Image.filename"
            :alt="blok.Image?.alt"
            density="x1"
            format="webp"
            loading="eager"
        />
        <div>{{ blok.Text }}</div>
    </div>
</template>

<script setup lang="ts">
defineProps<{ blok: any }>();
</script>

<style scoped lang="postcss">
.award-badge {
    @apply flex items-center w-[135px] bg-white border border-primary p-1 text-xs uppercase leading-none;
    img {
        @apply inline-block h-[25px] mr-1;
    }
}
</style>
